import { Options } from "vue-class-component";
import { factory } from "@cems-eco/core/src/utils/platform";
import { BaseAlarmComponent } from "./alarm";
import { ElLoading } from "element-plus";
import WebFilterComponent from "../filter/filter.web.vue";
import MobileFilterComponent from "../filter/filter.mobile.vue";
import storage from "@/storage";

@Options({
  props: {
    equipmentId: String,
    equipment: Object,
    searchMood: Boolean,
  },
  components: factory({
    web: {
      FilterComponent: WebFilterComponent,
    },
    mobile: {
      FilterComponent: MobileFilterComponent,
    },
  }),
})
export class BoxAlarmComponent extends BaseAlarmComponent {

  updateHeaders(): void {
    let auth = storage.getSync<any>(storage.AUTH);
    if (auth) {
      this.headers.Authorization = `Bearer ${auth["access_token"]}`;
    }
  }
}